<template>
  <router-link to="/vendi" class="ic-nav__link">Vendi</router-link>
</template>

<script>
// "Vendi" → la pagina per i privati che vogliono vendere casa (#750).
export default {
  name: 'SellNavLink',
}
</script>

<style scoped>
.ic-nav__link {
  font-size: 16px;
  font-weight: 500;
  color: var(--ic-ink, #1e1e1e);
  white-space: nowrap;
  padding: 10px 16px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.18s ease;
}
/* Stesso hover beige di "Ristruttura" e "Agenzie". */
.ic-nav__link:hover { background-color: #f2efe7; }
/* La visibilità responsive è governata dal layout ospite (ImmaginaHeader:
   sotto 1024px il link vive nel drawer mobile). */
</style>
